<mat-radio-group class="gap-2 grid mt-3">
  <mat-radio-button
    class="border-custom-primary"
    color="primary"
    [value]="item"
    *ngFor="let item of data">
    <div class="flex gap-2 items-center">
      <mat-icon
        class="w-10 h-10 mr-2 icon-size-20 fa-regular {{
          item.icon
        }}"></mat-icon>
      <div class="font-medium text-lg truncate">{{ item.name }}</div>
      <img class="w-10 h-10 object-scale-down" [src]="item.img" alt="" />
    </div>

    <div *ngIf="showPrice">
      <div class="font-bold text-lg">{{ item.price }}</div>
    </div>
  </mat-radio-button>

  <mat-radio-button class="border-custom-primary" color="primary">
    <div class="flex gap-2 items-center">
      <img class="w-10 h-10" [src]="'assets/logo-edvisor.svg'" alt="" />
      <div class="font-medium text-lg truncate">Edvisor Wallet</div>
    </div>

    <div *ngIf="showPrice">
      <div class="font-medium text-lg">$315,074.00 MXN</div>
    </div>
  </mat-radio-button>
</mat-radio-group>
